import 'bootstrap/dist/js/bootstrap.js';



// WEBPACK FOOTER //
// ../scss/bootstrap/bootstrap.js